import(/* webpackMode: "eager" */ "/codebuild/output/src2501290243/src/tenant-portal/src/app/layout.tsx")